import GeneralForm from "components/GeneralForm";

export default function Dados({ data, onChange, formConfig, edit }) {
  return (
    <>
      <GeneralForm
        config={formConfig}
        data={data}
        onChange={onChange}
        disabled={!edit}
      />
    </>
  )
}